import { render, staticRenderFns } from "./agecheck-content.vue?vue&type=template&id=00cc8f1a&scoped=true"
import script from "./agecheck-content.vue?vue&type=script&lang=ts"
export * from "./agecheck-content.vue?vue&type=script&lang=ts"
import style0 from "./agecheck-content.vue?vue&type=style&index=0&id=00cc8f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cc8f1a",
  null
  
)

export default component.exports